<template>
  <div class="js-vue page">
    <subpage-layout :theme="'dark'" :name="this.$route.name">
      <template v-slot:hero-image>
        <img src="../assets/img/hero-img-4.jpg" />
      </template>
      <template v-slot:hero-title>Vue / Nuxt</template>
      <template v-slot:description>
        <h2>Vue / Nuxt</h2>
        <p>
          I have been <strong>madly in love with Vue and Nuxt</strong> for
          more than 4 years now and still amazed with the
          <strong>ever-expanding possibilities of Javascript</strong>.
        </p>
        <p>
          It is becoming so much easier to bridge the gap between mobile apps
          and the web with buttery smooth page transitions and delightful
          interactions even on the web.
        </p>
        <p>
          It is so easy to spin up amazing sites with Vue paired with <strong>headless CMS like Strapi</strong>.
        </p>
        <p>
          <strong>Vue has been an absolute joy to work with</strong> not just
          for this portfolio site but also on numerous other projects.
        </p>
        <p>
          I am simply excited about the possibilities that lie ahead for a
          creative developer combining
          <strong>animation, data, Javascript and a bit of creativity</strong>.
        </p>
      </template>

      <template v-slot:skills>
        <featured-temp :kind="'sm'">
          <template v-slot:featured-title>Skills</template>
          <template v-slot:default>
            <ul>
              <li>Javascript (ES5, ES6)</li>
              <li>Vue</li>
              <li>Nuxt</li>
              <li>Angular</li>
              <li>Webpack</li>
              <li>Puppeteer</li>
              <li>Visual Regression Testing</li>
              <li>Firebase</li>
              <li>Strapi / Headless CMS</li>
              <li>StencilJs</li>
              <li>PWAs</li>
              <li>Netlify</li>
            </ul>
          </template>
        </featured-temp>
      </template>
      <template v-slot:pics>
        <project-picture>
          <template v-slot:pic>
            <video
              loop
              muted
              autoplay
              poster="../assets/img/navImg.jpg"
              class="video-tile"
            >
              <source src="../assets/video/navExample.mp4" type="video/mp4" />
            </video>
          </template>
          <template v-slot:label>
            <p>
              Idea for a Navigation Menu / Homepage.
              <br />Playing with Vue Router Animations and Nuxt to achieve
              native-Like Animations for Page Transitions on the Web
            </p>
          </template>
        </project-picture>
        <project-picture>
          <template v-slot:pic>
            <video
              loop
              muted
              autoplay
              poster="../assets/img/navImg.jpg"
              class="video-tile"
            >
              <source
                src="../assets/video/food-site-idea-nuxt.mp4"
                type="video/mp4"
              />
            </video>
          </template>
          <template v-slot:label>
            <p>Idea for Static Restaurant Site with Nuxt</p>
          </template>
        </project-picture>
      </template>
    </subpage-layout>
  </div>
</template>

<script>
import subpageLayout from "@/components/SubpageLayout";
import featuredTemp from "@/components/FeaturedTemp";
import projectPicture from "@/components/ProjectPicture";

export default {
  name: "js",
  data() {
    return {
      mockpage: "art",
    };
  },
  components: {
    subpageLayout,
    featuredTemp,
    projectPicture,
  },
};
</script>

<style lang="scss">
.js-vue {
  .img-wrapper {
    text-align: center;
  }
}

.video-tile {
  position: relative;
  left: 0;
  top: 0;
  max-width: 570px;
}
video {
  width: 100% !important;
  height: auto !important;
}
</style>
